module.exports = __webpack_public_path__ + "img/cent-sign.9ec1a62e.svg";